import React, { useRef } from 'react'
import { GRID_PHOTOS, POLAROID_PHOTOS } from '../data/heroCollage'
import { useHeroParallax } from '../hooks/useHeroParallax'

const HeroCollage: React.FC = () => {
  const wallRef = useRef<HTMLDivElement>(null)
  useHeroParallax(wallRef)

  return (
    <div className="v2-hero-collage" aria-label="Collage of people meeting through Ivy in Chicago" role="img">
      <div ref={wallRef} className="v2-hero-collage__wall">
        <div className="v2-hero-collage__grid">
          {GRID_PHOTOS.map((src, index) => (
            <div key={src + index} className="v2-hero-collage__grid-tile" style={{ backgroundImage: `url(${src})` }} />
          ))}
        </div>

        {POLAROID_PHOTOS.map((photo, index) => (
          <div
            key={`${photo.src}-${index}`}
            className="v2-hero-collage__polaroid"
            style={{
              left: `${photo.left}%`,
              top: `${photo.top}%`,
              width: `clamp(260px, ${photo.widthVw}vw, 720px)`,
              aspectRatio: photo.aspectRatio,
              transform: `rotate(${photo.rotateDeg}deg)`,
              backgroundImage: `url(${photo.src})`,
            }}
          />
        ))}
      </div>
      <div className="v2-hero-collage__scrim" />
    </div>
  )
}

export default HeroCollage
